import React from 'react';
import Notification from './Notification';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    children: React.ReactNode;
    count?: number;
}

const Avatar = ({ className = '', children, count }: Props) => (
    <span className="relative inline-block text-xs">
        <div
            className={twMerge(
                'relative flex size-10 items-center justify-center rounded-xl font-bold text-white',
                className,
            )}
        >
            {children}
        </div>
        {!!count && <Notification className="-me-1.5">{count}</Notification>}
    </span>
);

export default Avatar;
